import actionCreatorFactory from "typescript-fsa";
import {Permissions} from "@slices/Permissions/Permissions";

const actionCreator = actionCreatorFactory('sagas/iceClient');

export const loadUser = actionCreator.async<{
  token: string;
}, Permissions.Principal>('LOAD_USER');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/iceClient.actions.ts